<template>
  <div dusk="checkout-failed">
    <h2 class="mb-2 text-20 font-medium">
      {{
        /* translators: Primary heading of the failed checkout page */
        $t('lemonsqueezy_checkout.failed_message.heading')
      }}
    </h2>
    <p v-if="checkoutResponse.message" class="mb-2">
      {{
        /* translators: Sub heading of the failed checkout page  */
        $t('lemonsqueezy_checkout.failed_message.subheading')
      }}:<br />
      <span class="text-wedges-red">{{ checkoutResponse.message }}</span>
    </p>

    <p class="text-balance">
      <TranslatedText :text="$t('lemonsqueezy_checkout.failed_message')">
        <template #tryAgain>
          <a href="#" class="text-wtf-majorelle hover:underline" @click.prevent="tryAgain()">
            {{
              /* translators: The {tryAgain} placeholder of `lemonsqueezy_checkout.failed_message` */
              $t('lemonsqueezy_checkout.failed_message.try_again')
            }}
          </a>
        </template>
        <template #supportLink>
          <a href="https://www.lemonsqueezy.com/help" target="_blank" class="text-wtf-majorelle hover:underline">
            https://www.lemonsqueezy.com/help
          </a>
        </template>
        <template #cartId>
          <p>
            <code>{{ cart.id }}</code>
          </p>
        </template>
      </TranslatedText>
    </p>
  </div>
</template>

<script setup>
import TranslatedText from '@/Components/TranslatedText.vue'

defineProps({
  cart: {
    type: Object,
    required: true,
  },
  checkoutResponse: {
    type: Object,
    default: () => ({}),
  },
})

function tryAgain() {
  location.reload()
}
</script>
